// src/components/home/Hero.jsx
import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.5,
        staggerChildren: 0.3,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
    hover: { scale: 1.05 },
  };

  return (
    <section className="bg-[url('https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1')] bg-cover bg-center py-32 md:py-48 text-white relative flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="container mx-auto px-4 relative z-10 text-center">
        <motion.div
          className="max-w-xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1
            className="text-4xl font-bold font-heading mb-6 md:text-5xl lg:text-6xl"
            variants={textVariants}
          >
            Unlock Your Medical Potential
          </motion.h1>
          <motion.p
            className="text-lg mb-8 md:text-xl"
            variants={textVariants}
            transition={{ delay: 0.6 }}
          >
            Comprehensive study resources and expert guidance to ace your medical entrance exams.
          </motion.p>
          <motion.div
            className="flex justify-center gap-4"
            variants={buttonVariants}
            transition={{ delay: 0.9 }}
          >
            <motion.button
              className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-full focus:outline-none focus:shadow-outline transition duration-300"
              whileHover="hover"
            >
              Explore Courses
            </motion.button>
            <motion.button
              className="bg-transparent border border-white hover:border-purple-500 text-white font-bold py-3 px-6 rounded-full focus:outline-none focus:shadow-outline transition duration-300"
              whileHover="hover"
            >
              Learn More
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;